<template>
  <!--
    PoolaError — shown only when the singleton fetch fails BEFORE the first
    success (a later silent-refetch failure keeps the last good state on screen,
    see usePoolaDeal). A CONTENT FRAGMENT (no <f7-page>). Emits `retry` for the
    host to re-run usePoolaDeal.refresh.
  -->
  <div class="poola-error">
    <f7-icon
      f7="exclamationmark_triangle_fill"
      class="poola-error__icon"
      aria-hidden="true"
    ></f7-icon>
    <p class="poola-error__message">{{ resolvedMessage }}</p>
    <f7-button fill class="poola-error__btn" @click="$emit('retry')">{{
      $t('poola.buy.claim.refreshOffers')
    }}</f7-button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  // Optional override; defaults to the generic buy-error copy.
  message: {
    type: String,
    default: '',
  },
});

defineEmits(['retry']);

const { t } = useI18n({ useScope: 'global' });

const resolvedMessage = computed(() => props.message || t('poola.buy.error.generic'));
</script>

<style scoped>
.poola-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 56px 28px;
  gap: 16px;
}

.poola-error__icon {
  font-size: 48px;
  color: var(--poolit-text-muted);
}

.poola-error__message {
  color: var(--poolit-text-secondary);
  font-size: var(--poolit-font-size-body);
  line-height: var(--poolit-line-height-body);
  margin: 0;
  max-width: 320px;
}

.poola-error__btn {
  --f7-button-fill-bg-color: var(--poolit-primary-600);
  --f7-button-fill-text-color: #fff;
  --f7-button-fill-hover-bg-color: var(--poolit-primary-700);
  min-width: 180px;
}
</style>
